export { CookiesConsentRich, CookiesConsentRichWithStyles } from './CookiesConsentRich'
